module.exports = __webpack_public_path__ + "static/media/gitHubExploreLogo.04f6798f.svg";